import React from "react";
import { TextModal } from "./TextModal";

type ModalType = "privacy" | "terms" | null;

interface PrivacyTermsModalProps {
  openModal: ModalType;
  onClose: () => void;
}

export function PrivacyTermsModal({ openModal, onClose }: PrivacyTermsModalProps) {
  if (!openModal) return null;

  const title =
    openModal === "privacy" ? "MIVALTA PRIVACY PROMISE" : "MIVALTA TERMS OF USE";

  const content =
    openModal === "privacy"
      ? `Last updated: 2025

We don’t spy. We don’t sell. We don’t exploit.

No Tracking,
No tracking pixels, ad scripts, or sneaky analytics. Your visit here is your business — not ours.

No Third-Party Sharing,
We never sell or share your data. Not with marketers. Not with investors. Not with “strategic partners.” Not ever.

Email Signups,
When you sign up to stay in the loop, test the app, or contribute as a developer or designer, we store your email securely and use it only to contact you about MiValta’s launch, roadmap, testing phase, or ways to collaborate.
You can unsubscribe anytime with one click.
No spam. No data sales. Ever.

Data Minimization,
We only ask for what we truly need. No fluff. No hidden grabs.

Optional Contribution,
Joining as a tester or contributor? We’ll clearly explain what data is used and why. You’re in control at every step.

Local-First Philosophy,
The future MiValta app is built to prioritize on-device processing. Your data stays with you, not on some distant server farm.`
      : `Last updated: 2025

Use of Site,
This site is for informational purposes only. By using it, you agree not to reverse engineer, abuse, or misuse any part of it.

Intellectual Property,
All content on this site (designs, text, graphics, etc.) is owned by MiValta and protected by intellectual property laws.

No Warranty,
We provide this site “as is.” No guarantees. No liability for bugs, errors, or cosmic glitches.

MVP Phase Notice,
MiValta is in its early MVP phase. Any participation during this stage — including feedback, testing, or contribution — is strictly voluntary and does not constitute any right to ownership, compensation, or future affiliation.

Contributions,
If you offer to test or help us build, we welcome your support. But all contributions are voluntary. They do not imply employment, equity, or intellectual property rights unless we both sign something that says otherwise.

Changes,
We might update these terms. If we do, we’ll mark the date above. Keep an eye on it.`;

  return <TextModal title={title} content={content} onClose={onClose} />;
}
